import React, { useEffect, useState } from "react";
import core from "../../vendors/core-api";
import Breadcrumbs from "../../components/Breadcrumbs";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { SVGIcon } from "../../components/Base";
import { Redirect } from "react-router-dom";
import PacmanWrapper from "../../components/dashboard/PacmanWrapper";
import { Link } from "react-router-dom/";

export default function ReservationSelectionPage() {
  const api = core("pu").get();

  const [brands, setBrands] = useState([]);
  const [group, setGroup] = useState("");
  const [loading, setLoading] = useState(false);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [redirectTo, setRedirectTo] = useState(false);

  useEffect(() => {
    const getStores = async () => {
      try {
        setLoading(true);
        const result = await api.get("/brand/get-stores?source=reservations");
        if (result.data) {
          const brands = result.data.brands;
          setBrands(brands);
          setFilteredBrands(brands);
          setGroup(result.data.groupName);
          if (brands.length === 1) {
            if (brands[0].stores.length === 1) {
              if (brands[0].stores[0]._id) {
                setRedirectTo(
                  `/stores/${brands[0].stores[0]._id}/reservations/home`,
                );
              }
            }
          }
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    getStores();
  }, []);

  const search = (evt) => {
    evt.persist();
    if (evt.target.value) {
      setFilteredBrands(() => {
        const filteredBrands = brands.filter((brand) => {
          let valid = false;
          if (
            brand.name.toLowerCase().indexOf(evt.target.value.toLowerCase()) >
            -1
          ) {
            valid = true;
          }
          const validStores = brand.stores.filter((store) =>
            store.hasOwnProperty("name")
              ? store.name
                  .toLowerCase()
                  .indexOf(evt.target.value.toLowerCase()) > -1
              : null,
          );
          if (validStores.length > 0) {
            valid = true;
          }
          return valid;
        });
        return filteredBrands;
      });
    } else {
      setFilteredBrands(() => {
        const filteredBrands = [...brands];
        return filteredBrands;
      });
    }
  };

  return loading ? (
    <PacmanWrapper removeBackgroundColor />
  ) : redirectTo ? (
    <Redirect to={redirectTo} />
  ) : (
    <div>
      <div className="row">
        <div className="col-md-9 col-sm-12">
          <Breadcrumbs>
            <Breadcrumbs.Item text={group} />
            <Breadcrumbs.Item
              text="Reservations"
              link={`/reservations`}
              active="true"
            />
          </Breadcrumbs>
        </div>
        <div className="col-md-2 col-sm-6">
          <input
            type="text"
            placeholder="Search..."
            className="form-control"
            onChange={search}
          />
        </div>
      </div>
      <br />
      <br />

      <div className="row pt-10" style={{ paddingLeft: "3rem" }}>
        {filteredBrands &&
          filteredBrands.map((brand, index) => {
            return (
              <div key={index} className="d-flex">
                <Link
                  className="px-8 store-name-card"
                  key={index}
                  to={`/brand/${brand._id}/reservations/new`}
                >
                  <div className="d-flex align-items-center">
                    <SVGIcon
                      icon={`Home/Building`}
                      variant="primary"
                      className="svg-icon-lg mr-1"
                    />
                    <span className="ml-1 display-5 font-weight-bolder">
                      {brand.name}
                    </span>
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    </div>
  );
}
